<button #profileMenu class="profile" data-private
        [style.background-image]="background"
>
    <kendo-contextmenu #profilePopup [alignToAnchor]="true" [target]="profileMenu"
                       [popupAlign]="{horizontal: 'center', vertical: 'top'}"
                       showOn="click">
    <ng-template kendoContextMenuTemplate>
      <div (click)="onOpenProfileSettings()" class="k-p-3 k-cursor-pointer">
        <span class="k-text-nowrap" translate>ui.profile_menu.actions.profile_settings</span>
      </div>
      <div (click)="onLogout()" class="k-p-3 k-cursor-pointer">
        <span class="k-text-nowrap" translate>ui.profile_menu.actions.logout</span>
      </div>
    </ng-template>
  </kendo-contextmenu>
</button>
